module.exports = {
	"global": {
		"cssNamespace": "mjmm",
		"breakpoints": {
			"small": 600,
			"medium": 768,
			"large": 1280
		}
	},
	"mapbox": {
		"accessToken": "pk.eyJ1IjoiY29ycmVjdGl2IiwiYSI6ImNqNTJ1OXhrcDBma3oycWx5MTI4OXpzaTQifQ.rKZroMYP1Kr4YUDJ_dJ_2g",
		"mapId": "mj-map",
		"labels": "mapbox://styles/mapbox/light-v9",
		"sources": {
			"normal": {
				"6": {
					"mapId": "correctiv.1qbq67ar",
					"layer": "mj-munis-all_wohnort_lowres-aq9u5y"
				},
				"8": {
					"mapId": "correctiv.9njqau0t",
					"layer": "mj-munis-all_wohnort_midres-3x0j84"
				},
				"11": {
					"mapId": "correctiv.cmpju65n",
					"layer": "mj-munis-all_wohnort_highres-91u9fd"
				}
			},
			"hotspots": {
				"6": {
					"mapId": "correctiv.90rk36rl",
					"layer": "mj-munis-all_arbeitsort_lowre-b84p96"
				},
				"8": {
					"mapId": "correctiv.bq557ytm",
					"layer": "mj-munis-all_arbeitsort_midre-a9an9g"
				},
				"11": {
					"mapId": "correctiv.1o7yml0c",
					"layer": "mj-munis-all_arbeitsort_highr-1m7gfm"
				}
			}
		},
		"views": {
			"normal": {
				"property": "pwa",
				"colors": [
					"#ffffe5",
					"#fff7bc",
					"#fee391",
					"#fec44f",
					"#fe9929",
					"#ec7014",
					"#cc4c02",
					"#993404",
					"#662506"
				],
				"domain": [
					0,
					10
				]
			},
			"hotspots": {
				"property": "pai",
				"colors": [
					"#ffffff",
					"#f0f0f0",
					"#d9d9d9",
					"#bdbdbd"
				],
				"domain": [
					0,
					20
				],
				"extraStops": [
					[
						20,
						"#ec7014"
					],
					[
						25,
						"#993404"
					],
					[
						30,
						"#662506"
					]
				]
			}
		},
		"bBox": [
			-3.66,
			45.4,
			24.88,
			55.48
		],
		"center": [
			10.45,
			51.18
		],
		"initZoom": 6,
		"maxZoom": 12,
		"minZoom": 6
	},
	"historyChart": {
		"normal": {
			"keys": [
				"pwi_h",
				"pwa_h",
				"pwn_h"
			],
			"yExtent": [
				0,
				15
			],
			"yTickValues": [
				0,
				5,
				10,
				15
			]
		},
		"hotspots": {
			"keys": [
				"pai_h",
				"paa_h",
				"pan_h"
			],
			"yExtent": [
				0,
				30
			],
			"yTickValues": [
				0,
				10,
				20,
				30
			]
		},
		"width": 300,
		"height": 80,
		"margin": {
			"top": 10,
			"right": 20,
			"bottom": 20,
			"left": 20
		},
		"xExtent": [
			"2003",
			"2016"
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./src/config.json
// module id = 50
// module chunks = 0